module.exports = __webpack_public_path__ + "static/media/DrugOrPlanet.d3352245.jpg";